import { createAsyncThunk } from "@reduxjs/toolkit";

import { EndPoints } from "../../api/endpoints";
import axiosClient from "../../api/axiosClient";

export type AddCategory = {
  name: string;
  icon: string;
};

export type UpdateCategory = {
  id: string;
  name: string;
  icon: string;
};

export const getCategories = createAsyncThunk(
  "categories",
  async (_, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(EndPoints.categories);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const addCategory = createAsyncThunk(
  "add/category",
  async (data: AddCategory, { dispatch, rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.put(EndPoints.categories, data);
      dispatch(getCategories());
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const updateCategory = createAsyncThunk(
  "update/category",
  async (data: UpdateCategory, { dispatch, rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.patch(
        `${EndPoints.categories}/${data.id}`,
        data
      );
      dispatch(getCategories());
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const deleteCategory = createAsyncThunk(
  "delete/category",
  async (id: string, { dispatch, rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.delete(
        `${EndPoints.categories}/${id}`
      );
      dispatch(getCategories());
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);
